import { render, staticRenderFns } from "./CrudCombobox.vue?vue&type=template&id=e973f204"
import script from "./CrudCombobox.vue?vue&type=script&lang=js"
export * from "./CrudCombobox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports